import axiosFetch from './config';
// import axiosFetch from './configStsging';

export const getcontactInfo = async () => {
    let token = localStorage.getItem("token")
    return axiosFetch({
        method: 'GET',
        url: `/contactInfo`,
        headers: {
            Authorization: 'Bearer ' + token,
        },
    })
}

export const deleteContactInfoById = async (Id) => {
    let token = localStorage.getItem("token")
    return axiosFetch({
        method: 'DELETE',
        url: `/contactInfo/${Id}`,
        headers: {
            Authorization: 'Bearer ' + token,
        }
    })
}

export const contactInfoSave = async (data) => {
    const token = localStorage.getItem("token")
    return axiosFetch({
        method: 'POST',
        url: '/contactInfo',
        data,
        headers: {
            Authorization: 'Bearer ' + token,
        }
    })
}

export const phoneNumberOTPSendCode = async (data) => {
    let token = localStorage.getItem("token")
    return axiosFetch({
        method: 'POST',
        data: data,
        url: '/contactInfo/otp/send',
        headers: {
            Authorization: 'Bearer ' + token,
        },
    });
};

export const emailOTPSendCode = async (data) => {
    let token = localStorage.getItem("token")
    return axiosFetch({
        method: 'POST',
        data: data,
        url: '/contactInfo/otp/send',
        headers: {
            Authorization: 'Bearer ' + token,
        },
    });
};
